<div [class]="'mzic-divider--' + variant"></div>
